export default class File {
  static PERMISSIONS = {
    READ: 'READ',
    EDIT: 'EDIT',
    CREATE: 'CREATE',
    DELETE: 'DELETE',
  };
}
